import { Col, Row } from "react-bootstrap";
import VrboConnected from "./VrboConnected";
import VrboNotConnected from "./VrboNotConnected";
import useVrboIntegrationRecord from "./useVrboIntegrationRecord";

export default function VRBOIntegration(
    props: {
        propertyId: string
        title?: string
    }
) {
    const {
        propertyId,
        title = 'VRBO Integration',
    } = props

    const record = useVrboIntegrationRecord(propertyId)
    const { integrationData, isLoading, error } = record

    return (
        <Row>
            <Col>
                {title && (
                    <h4>{title}</h4>
                )}

                {error && (
                    <p>Error loading integration data</p>
                )}

                {isLoading ? (
                    <p>Loading...</p>
                ) : integrationData ? (
                    <VrboConnected propertyId={propertyId} record={record} />
                ) : (
                    <VrboNotConnected propertyId={propertyId} record={record} />
                )}
            </Col>
        </Row>
    )
}
